/* eslint-disable no-magic-numbers */
import { findCurrUser, getUserAllTenants, getUserApplications, getAllResources, querySupplierInFoBySupplierCode, getSupplierContactsInfos, getSupplierQualifications,
    getItsmLogin, getBlackWhiteSwitch } from '@/modules/index/api/user';
import lang from '@/lang/index';
import config from '@/config/user.env';
import { MessageBox, Message } from 'element-ui';
import { logout } from '@/utils/index';
import utils from '@/utils/common.js';

export default {
    state: {
        user: {},
        authority: '',
        appId: config.appId,
        lang: {},
        tenantInfo: {},
        currentTenant: {},
        appList: [],
        applicationCode: '',
        supplier: {},
        qualifications: {},
        contactsMobile: '',
        mipNum: 1,
        itsmToken: ''
    },
    getters: {
        user: state => state.user,
        appId: state => state.appId,
        authority: state => state.authority,
        menus: state => {
            if (state.authority) {
                return state.authority;
            }
            return [];
        },
        lang: state => state.lang,
        tenantInfo: state => state.tenantInfo,
        currentTenant: state => state.currentTenant,
        appList: state => state.appList,
        btnPermissions: state => state.btnPermissions,
        applicationCode: state => state.applicationCode,
        supplier: state => state.supplier,
        qualifications: state => state.qualifications
    },
    mutations: {
        setMipNum(state, val) {
            state.mipNum = val;
        },
        getBtnPermissions(state, btnPermissions) {
            state.btnPermissions = btnPermissions;
        },
        updateUserInfo(state, user) {
            state.user = user;
        },
        updateAuthority(state, authority) {
            state.authority = authority;
        },
        updateLang(state, _lang) {
            state.lang = _lang;
        },
        updateTenant(state, _tenantInfo) {
            state.tenantInfo = _tenantInfo;
        },
        updateCurrenTenant(state, _tenantInfo) {
            state.currentTenant = _tenantInfo;
        },
        updateAppList(state, _appList) {
            state.appList = _appList;
        },
        updateApplicationCode(state, _applicationCode) {
            state.applicationCode = _applicationCode;
        },
        updateSupplier(state, supplier) {
            state.supplier = supplier;
        },
        updateQualifications(state, qualifications) {
            state.qualifications = qualifications;
        },
        updateMobile(state, contactsMobile) {
            state.contactsMobile = contactsMobile;
        },
        updateItsmToken(state, itsmToken) {
            state.itsmToken = itsmToken;
        }
    },
    actions: {
        /**
         * 初始化系统
         * @param {*} param0
         */
        async initSystem({ commit, dispatch }) {
            const lspOrigin = ['lsp.annto.com', 'lsp-ver.annto.com', 'lsp-uat.annto.com']
            // 判断当前是LSP域名
            if (lspOrigin.some(item => window.location.href.includes(item))) {
                const linkRes = await getBlackWhiteSwitch().catch(err => {})
                // isWhiteFlag为'1'，代表是黑名单
                if (linkRes && +linkRes.code === 0 && +linkRes.data.isWhiteFlag === 1) {
                    MessageBox.alert(`<span>您的业务已迁移至新系统<a href="${config.elUrl}">${config.elUrl}</a>，以当前账号登录访问即可。若有疑问，请联系许彦祺！（13661930692）</span>`, '错误', {
                        dangerouslyUseHTMLString: true,
                        showClose: false,
                        confirmButtonText: '立即前往',
                        callback: function(action, instance) {
                            location.href = config.elUrl
                        }
                    })
                    return false
                }
            }
            const params = {
                listFlag: 1,
                pageNo: 1,
                pageSize: 10
            };
            return Promise.all([findCurrUser(), getUserAllTenants(params)]).then(res => {
                if (+res[0].code === 0 && +res[1].code === 0) {
                    commit('updateUserInfo', res[0].data);
                    if (!res[1].data.currentTenant) {
                        MessageBox.alert('不存在默认租户，请联系管理员重新登录!', '错误', {
                            confirmButtonText: '确定',
                            callback: action => {
                                logout(true);
                            }
                        });
                        return false;
                    }
                    commit('updateTenant', res[1].data.tenants ? res[1].data.tenants : {});
                    commit('updateCurrenTenant', res[1].data.currentTenant ? res[1].data.currentTenant : {});
                    return getUserApplications({
                        userCode: res[0].data.userCode,
                        tenantCode: res[1].data.currentTenant.tenantCode
                    }).then(response => {
                        if (response && +response.code === 0) {
                            if (!response.data.length) {
                                MessageBox.alert('不存在应用列表，请联系管理员重新登录!', '错误', {
                                    confirmButtonText: '确定'
                                });
                                return false;
                            }
                            commit('updateAppList', response.data);
                            const appId = response.data.find(item => {
                                return item.applicationDomain && item.applicationDomain.indexOf(window.location.pathname) > -1;
                            });
                            commit('updateApplicationCode', appId ? appId['applicationCode'] : '');
                            return getAllResources({
                                userCode: res[0].data.userCode,
                                applicationCode: appId && appId['applicationCode'] ? appId['applicationCode'] : '',
                                tenantCode: res[1].data.currentTenant.tenantCode
                            }).then(resData => {
                                if (resData && +resData.code === 0) {
                                    const btnPermissions = utils.getResourceIds(resData.data);
                                    commit('getBtnPermissions', btnPermissions);
                                    commit('updateAuthority', resData.data[0] && resData.data[0].subResources && resData.data[0].subResources.length ? resData.data[0].subResources : []);
                                    if (resData.data && resData.data.length === 0) {
                                        Message.error({
                                            message: '您没有菜单权限',
                                            showClose: true
                                        });
                                    }
                                    const userCode = res[0].data.userCode.toLocaleLowerCase();
                                    if (userCode.indexOf('hc') === 0 || userCode.indexOf('hp') === 0) {
                                        return querySupplierInFoBySupplierCode(res[0].data.userCode).then(resSupplier => {
                                            if (resSupplier && +resSupplier.code === 0) {
                                                commit('updateSupplier', resSupplier.data);
                                                // 获取供应商联系方式
                                                dispatch('getMobile', userCode);
                                                // 获取 itsm token
                                                dispatch('getItsmToken', userCode);
                                                // 获取供应商预警信息
                                                return getSupplierQualifications(res[1].data.currentTenant.tenantCode).then(resQualifications => {
                                                    if (resQualifications && +resQualifications.code === 0) {
                                                        commit('updateQualifications', resQualifications.data);
                                                    }
                                                    return true;
                                                });
                                            } else {
                                                setTimeout(() => {
                                                    logout(true);
                                                }, 3000);
                                            }
                                        });
                                    } else {
                                        MessageBox.alert(`当前账号${userCode}不是供应商类型，供应商账号为hc、hp开头，请联系管理员开通供应商账号`, '错误', {
                                            confirmButtonText: '确定',
                                            callback: action => {
                                                logout(true);
                                            }
                                        });
                                    }
                                } else {
                                    Message.error(resData.msg);
                                    return false;
                                }
                            });
                        } else {
                            Message.error(response.msg);
                            return false;
                        }
                    });
                } else {
                    if (res[0] && +res[0].code !== 0) {
                        MessageBox.alert(res[0].msg || '接口返回异常', '错误', {
                            confirmButtonText: '确定',
                            callback: action => {
                                logout(true);
                            }
                        });
                    }
                    if (res[1] && +res[1].code !== 0) {
                        MessageBox.alert(res[1].msg || '接口返回异常', '错误', {
                            confirmButtonText: '确定',
                            callback: action => {
                                logout(true);
                            }
                        });
                    }
                }
                // return +res[0].code === 0 && +res[1].code === 0;
            });
        },
        getMobile({ commit }, userCode) {
            getSupplierContactsInfos({ userCode }).then(res => {
                if (res && +res.code === 0 && res.data.list.length) {
                    commit('updateMobile', res.data.list[0].contactsMobile);
                }
            });
        },
        getItsmToken({ commit }, userCode) {
            getItsmLogin({ userCode }).then(res => {
                if (res && +res.code === 0) {
                    commit('updateItsmToken', res.data.tokenId);
                }
            });
        },
        UPDATE_LANG({ commit, state }) {
            const langSettings = lang.initLanguage(state.user.fdLangType);
            commit('updateLang', langSettings);
            return langSettings;
        }
    }
};
